import { Flex, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  /** Rendered at the right of the label row -- the "+" on Private messages. */
  action?: ReactNode;
};

/** The small uppercase heading above each section of the Communication page. */
export function SectionLabel({ children, action }: Props) {
  return (
    <Flex align="center" justify="space-between" px={4} pt={5} pb={2} minH="32px">
      <Text
        fontSize="xs"
        fontWeight="bold"
        letterSpacing="wide"
        textTransform="uppercase"
        color="volyx.textSecondary"
      >
        {children}
      </Text>
      {action}
    </Flex>
  );
}
